import updatePasswordPage from '@/pages/update-password'
import RoleManage from '@/pages/system/role-manage'
import EditRoomStatus from '@/pages/system/editRoomStatus'

export const updatePassword = {
  path: 'updatePassword',
  component: updatePasswordPage
}

export const roleManage = {
  path: 'system/rolesManage',
  component: RoleManage
}

// 修改远期房态
export const editRoomStatus = {
  path: 'system/editRoomStatus',
  component: EditRoomStatus
}



// WEBPACK FOOTER //
// ./src/router/system.js